import React from 'react';

const Header = () => (
    <div id="header" className="header">
        <h2 style={{ marginBottom: '0px', marginTop: '0px' }}>OliverPhotographer</h2>
    </div>
)

export default Header;
 